document.addEventListener("DOMContentLoaded", () => {
  const items = document.querySelectorAll(".showcase-col-item");
  const prevPageBtn = document.querySelector(".prev-page");
  const nextPageBtn = document.querySelector(".next-page");
  const pcPageNumbers = document.querySelector(".page-numbers.pc-show");
  const mbPageNumbers = document.querySelector(".page-numbers.mb-show");
  let itemsPerPage = 12;
  let totalPages = Math.ceil(items.length / itemsPerPage);
  let currentPage = 1;
  const mediaQuery = window.matchMedia("(max-width: 500px)");

  // 生成页码按钮
  function generatePageButtons(container, totalPages, activePage = 1) {
    container.innerHTML = "";

    for (let i = 1; i <= totalPages; i++) {
      const btn = document.createElement("button");
      btn.className = `page-btn ${i === activePage ? "page-active" : ""}`;
      btn.dataset.page = i;
      btn.textContent = i;

      btn.addEventListener("click", () => {
        goToPage(i);
      });

      container.appendChild(btn);
    }
  }

  // 处理屏幕尺寸变化
  function handleScreenChange(e) {
    const wasMobile = itemsPerPage === 4;
    const isMobile = e.matches;

    if (isMobile !== wasMobile) {
      const positionRatio = currentPage / totalPages;
      itemsPerPage = isMobile ? 4 : 12;
      totalPages = Math.ceil(items.length / itemsPerPage);
      currentPage = Math.max(
        1,
        Math.min(totalPages, Math.round(positionRatio * totalPages))
      );
      generatePageButtons(
        isMobile ? mbPageNumbers : pcPageNumbers,
        totalPages,
        currentPage
      );
      goToPage(currentPage);
    }
  }

  // 切换到指定页码
  function goToPage(page) {
    if (page < 1 || page > totalPages) return;

    currentPage = page;

    // 计算当前页应显示的项目范围
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = currentPage * itemsPerPage;

    // 更新项目显示状态
    items.forEach((item, index) => {
      const isVisible = index >= startIndex && index < endIndex;
      item.style.display = isVisible ? "block" : "none";

      if (isVisible) {
        item.style.opacity = "0";
        setTimeout(() => {
          item.style.opacity = "1";
        }, 50);
      }
    });

    // 更新当前设备类型对应的页码按钮状态
    const activeContainer = mediaQuery.matches ? mbPageNumbers : pcPageNumbers;
    activeContainer.querySelectorAll(".page-btn").forEach((btn) => {
      const pageNum = parseInt(btn.dataset.page);
      if (pageNum === currentPage) {
        btn.classList.add("page-active");
      } else {
        btn.classList.remove("page-active");
      }
    });

    // 更新上一页/下一页按钮状态
    prevPageBtn.disabled = currentPage === 1;
    nextPageBtn.disabled = currentPage === totalPages;
  }

  prevPageBtn.addEventListener("click", () => {
    if (currentPage > 1) {
      goToPage(currentPage - 1);
    }
  });

  nextPageBtn.addEventListener("click", () => {
    if (currentPage < totalPages) {
      goToPage(currentPage + 1);
    }
  });

  handleScreenChange(mediaQuery);
  mediaQuery.addEventListener("change", handleScreenChange);

  generatePageButtons(pcPageNumbers, Math.ceil(items.length / 12), 1);
  generatePageButtons(mbPageNumbers, Math.ceil(items.length / 4), 1);
});
